export const ADD = 'entities/volunteerTimeOff/ADD';
export const ADD_MULTIPLE = 'entities/volunteerTimeOff/ADD_MULTIPLE';
export const REMOVE = 'entities/volunteerTimeOff/REMOVE';
